var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',{attrs:{"label":"Přezdívka","type":"text","name":"nickname","value":_vm.value,"help":_vm.help,"validation":"bail|alphaExtendedSpecial|emptyOrMin:3|max:30,length","validation-messages":{
    alphaExtendedSpecial: 'Povolené jsou pouze znaky abecedy',
    emptyOrMin: 'Přezdívka musí obsahovat minimálně 3 znaky',
    max: 'Přezdíva nesmí být delší než 30 znaků',
  },"error-behavior":"submit","disabled":_vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }